<template>
    <div>
        <div class="home apply">
            <el-form label-width="80px">
                <div class="redo" style="margin-bottom: 20px">
                    <el-row>
                        <el-col :span="6"><span style="color: #008cff">申请查询结果</span></el-col>
                    </el-row>
                </div>
                <div>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label-width="150px" label="姓名或单位名称">
                                <p class="wordWrap">{{ form.name }}</p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label-width="150px" label="申请索引号">
                                <p class="wordWrap">{{ form.id }}</p>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label-width="150px" label="标题">
                                <p class="wordWrap">{{ form.title }}</p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label-width="150px" label="申请时间">
                                <p class="wordWrap">{{ form.createTime }}</p>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label-width="150px" label="办理状态">
                                <p class="wordWrap">{{ form.status }}</p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label-width="150px" label="答复类型">
                                <p class="wordWrap">{{ form.replyType }}</p>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="24">
                            <el-form-item label-width="150px" label="答复内容">
                                <p class="wordWrap">{{ form.replyContent }}</p>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row v-if="tableData && tableData.length > 0">
                        <el-col :span="24">
                            <el-form-item label-width="150px" label="附件">
                                <el-row v-for="(item,index) in tableData" :key="index" class="fujianContent">
                                    <el-col :span="20" class="fujianInner"><a
                                            :href='urlActionDrawFile+"?attachmentId="+item.id' class="fujianA">
                                        <i class="el-icon-paperclip"></i>&nbsp&nbsp{{item.fileName}}.{{item.fileExt}}</a>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row v-if="form.additionInfo">
                        <el-col :span="24">
                            <el-form-item label-width="150px" label="已补正信息">
                                <p class="wordWrap">{{ form.additionInfo }}</p>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row v-if="tableData1 && tableData1.length > 0">
                        <el-col :span="24">
                            <el-form-item label-width="150px" label="已补正信息附件">
                                <el-row v-for="(item,index) in tableData1" :key="index" class="fujianContent">
                                    <el-col :span="20" class="fujianInner"><a
                                            :href='urlActionDrawFile+"?attachmentId="+item.id' class="fujianA">
                                        <i class="el-icon-paperclip"></i>&nbsp&nbsp{{item.fileName}}.{{item.fileExt}}</a>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </div>
                <div class="footer">
                    <el-button type="primary"><a :href='urlActionDraw+"?applicationId="+form.id'
                                                 style="text-decoration: none;color: #ffffff;">下载申请表</a></el-button>
                    <el-button type="primary"><a :href='urlActionDrawResult+"?applicationId="+form.id'
                                                 style="text-decoration: none;color: #ffffff;">下载查询结果</a></el-button>
                    <el-button type="primary" @click="$router.go(-1)">返回</el-button>
                </div>
            </el-form>

        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                tableData: [],
                tableData1: [],
                urlActionDrawFile: window.SITE_CONFIG['baseUrl'] + '/file/downloadFile',
                urlActionDraw: window.SITE_CONFIG['baseUrl'] + '/export/downloadApp',
                urlActionDrawResult: window.SITE_CONFIG['baseUrl'] + '/export/dwnQueryResult',
                id: '',
                form: {
                    name: '',
                    id: '',
                    title: '',
                    createTime: '',
                    status: '',
                    replyType: '',
                    replyContent: '',
                },
            }
        },
        mounted() {
            this.getIdSelect()
            this.getFileMetaData()
            this.getFileMetaData1()

        },
        methods: {
            getIdSelect() {
                const detailid = this.$route.query.id2
                this.id = detailid
                this.$axios({url: '/application/queryByAppId', method: 'get', params: {id: this.id}}).then(({data}) => {
                    const that = this
                    that.form = data.result
                })
            },
            getFileMetaData() {
                const fileViewId = this.$route.query.id3
                var fileData = {
                    tableUuid: fileViewId,
                    tableName: 'applicationForm',
                    tableKey: 'formalReply'
                }
                this.$axios({url: '/file/getFileMetaData', method: 'post', data: fileData}).then(({data}) => {
                    this.tableData = data.result
                })
            },

            getFileMetaData1() {
                const fileViewId1 = this.$route.query.id2
                var fileData = {
                    tableUuid: fileViewId1,
                    tableName: 'applicationForm',
                    tableKey: 'basicInformationBzAttach'
                }
                this.$axios({url: '/file/getFileMetaData', method: 'post', data: fileData}).then(({data}) => {
                    this.tableData1 = data.result
                })
            },

            route_goFun4(name) {
                this.$router.push({
                    path: '/select-result',
                    query: {
                        name: name,
                        id: 4
                    }
                })
            }

        }

    }

</script>

<style>
    .apply {
        text-align: center;
        width: 60%;
        margin: 0 auto;
        padding: 20px 10px;
    }

    .apply .footer {
        margin-top: 20px;
        margin-bottom: 40px;
    }
</style>
